import { products as productConstants } from '@picsio/db/src/constants';

import normalizeWeightHelpers from '@picsio/db/src/collections/products/helpers/normalizeWeight';

export const getTextFromRichText = (richText) => {
  if (richText.type === 'text') return richText.value;
  if (richText.children && Array.isArray(richText.children)) {
    return richText.children.map((child) => getTextFromRichText(child)).join(' ');
  }
  return '';
};

export const PRODUCT_UNITS = productConstants.units;

export const PRODUCT_DEFAULT_UNITS = productConstants.defaultUnits;

export const PRODUCT_DEFAULT_CURRENCY = productConstants.defaultCurrency;

export const MONEY_CURRENCY_CODES = productConstants.currency;

export const UNIT_DISPLAY_LABELS = {
  weight: {
    grams: 'g',
    kilograms: 'kg',
    ounces: 'oz',
    pounds: 'lb',
  },
  dimension: {
    millimeters: 'mm',
    centimeters: 'cm',
    meters: 'm',
    inches: 'in',
    feet: 'ft',
    yards: 'yd',
  },
  volume: {
    milliliters: 'ml',
    centiliters: 'cl',
    liters: 'L',
    cubic_meters: 'm³',
    us_fluid_ounces: 'fl oz',
    us_pints: 'pt',
    us_quarts: 'qt',
    us_gallons: 'gal',
    imperial_fluid_ounces: 'imp fl oz',
    imperial_pints: 'imp pt',
    imperial_quarts: 'imp qt',
    imperial_gallons: 'imp gal',
  },
};

export function getUnitDisplayLabel(type, unit) {
  return UNIT_DISPLAY_LABELS[type]?.[unit] || unit;
}

export function formatDimensionUnitLabel(type, unitId) {
  return getUnitDisplayLabel(type, unitId);
}

export function buildWeightSelectOptions() {
  return PRODUCT_UNITS.weight.map((unit) => ({
    id: unit,
    value: getUnitDisplayLabel('weight', unit),
  }));
}

export const { normalizeWeight } = normalizeWeightHelpers;
export const { normalizeWeightUnit } = normalizeWeightHelpers;
